import { Container, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { IUser } from '@customTypes/user';
import StudentAttendanceReport from 'components/AttendanceReport/StudentAttendanceReport';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs/HeaderBreadcrumbs';
import Page from 'components/Page/Page';
import ScheduleCalendar from 'components/ScheduleCalendar/ScheduleCalendar';
import { getRegisteredChildren } from 'external/firebase/firestore/collections/users';
import useAuth from 'hooks/useAuth';

import useLocales from 'hooks/useLocales';

import Modules from './sections/Modules';
import Notifications from './sections/Notifications';

interface DashboardProps {}

const Dashboard: React.FunctionComponent<DashboardProps> = () => {
    const { profile } = useAuth();
    const { translate } = useLocales();

    const [selectedChild, setSelectedChild] = useState<string | undefined>(undefined);
    const [children, setChildren] = useState<IUser[]>([]);
    const [error, setError] = useState<string | undefined>();
    const [isLoading, setIsLoading] = useState(true);

    const fetchChildren = async () => {
        try {
            const children = await getRegisteredChildren();
            setChildren(children);
            setSelectedChild(children[0]?.id);
            setError(undefined);
            setIsLoading(false);
        } catch (err) {
            console.error(err);
            // TODO: Fix error handling
            // setError(translate(resChildren.code));
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (profile?.role === 'parent') {
            fetchChildren();
        }
    }, [profile?.role]);

    return (
        <Page title={`${translate('dashboard')} | CodeAcademy Kids`}>
            <Container maxWidth='xl'>
                <HeaderBreadcrumbs heading={translate('dashboard')} />

                <Notifications />

                {profile?.role === 'parent' && (
                    <Stack spacing={3} sx={{ mb: 3, maxWidth: { sm: '100%', md: '25%' } }}>
                        <FormControl>
                            <InputLabel id='child-select-label'>{translate('child')}</InputLabel>
                            <Select
                                labelId='child-select-label'
                                value={selectedChild || ''}
                                defaultValue={selectedChild || ''}
                                label={translate('child')}
                                onChange={event => setSelectedChild(event.target.value)}
                            >
                                {children.map(child => (
                                    <MenuItem key={child.id} value={child.id}>
                                        {child.firstName} {child.lastName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                )}

                {profile?.role === 'parent' ? (
                    <Stack spacing={3}>
                        <StudentAttendanceReport selectedChild={children.find(child => child.id === selectedChild)} />
                        <ScheduleCalendar selectedUser={children.find(child => child.id === selectedChild)} />
                    </Stack>
                ) : (
                    <Modules />
                )}
            </Container>
        </Page>
    );
};

export default Dashboard;
